/*
  Einführungspreis (A/B "angebote_v1"), Gegenstück zu snippets/flex-einfuehrung.liquid,
  snippets/price.liquid (Parameter einfuehrung) und snippets/flex-produkt-kachel.liquid.
  - Blendet Abgelaufenes aus (Seiten werden gecacht): jedes Element mit
    data-flex-einf-ende (Unix-Sekunden) bekommt danach .is-abgelaufen
    (.flex-einf → ausgeblendet, .flex-einf-swap → wieder regulärer Preis).
  - Countdown alle 30 s: PDP-Kacheln Tage/Std./Min. + Fortschrittsbalken
    (verbleibender Anteil der 7 Tage), Klartext [data-flex-einf-rest],
    Kurzform der Produktkacheln [data-flex-einf-kurz] („6 T“ „21 Std.“).
  - Variantenwechsel: setzt den „Danach“-Preis der PDP-Box aus deren
    Variantenliste (Dawn: change am input[name=id] + pubsub variantChange).
  - Nach AJAX-Updates (Collection-Filter, Sortierung, Paginierung) sofort neu.
  Ohne die Elemente (Variante A, andere Seiten) passiert nichts.
*/
(function () {
  if (window.__flexEinf) return;
  window.__flexEinf = true;

  var SIEBEN_TAGE = 7 * 86400;

  function teile(sek) {
    var d = Math.floor(sek / 86400);
    var h = Math.floor((sek % 86400) / 3600);
    var m = Math.floor((sek % 3600) / 60);
    if (d === 0 && h === 0 && m === 0) m = 1;
    return { d: d, h: h, m: m };
  }

  function restText(sek) {
    var z = teile(sek);
    var t = [];
    if (z.d > 0) t.push(z.d + (z.d === 1 ? ' Tag' : ' Tage'));
    if (z.d > 0 || z.h > 0) t.push(z.h + ' Std.');
    t.push(z.m + ' Min.');
    return t.join(' ');
  }

  /* Kurzform für Produktkacheln: höchstens zwei Stellen */
  function kurzTeile(sek) {
    var z = teile(sek);
    if (z.d > 0) return [z.d + ' T', z.h + ' Std.'];
    if (z.h > 0) return [z.h + ' Std.', z.m + ' Min.'];
    return [z.m + ' Min.'];
  }

  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  function text(el, sel, wert) {
    var t = el.querySelector(sel);
    if (t && t.textContent !== wert) t.textContent = wert;
  }

  function aktualisiere(el, rest) {
    var r = el.querySelector('[data-flex-einf-rest]');
    if (r) r.textContent = restText(rest);

    if (el.querySelector('[data-flex-einf-d]')) {
      var z = teile(rest);
      text(el, '[data-flex-einf-d]', String(z.d));
      text(el, '[data-flex-einf-dl]', z.d === 1 ? 'Tag' : 'Tage');
      text(el, '[data-flex-einf-h]', zwei(z.h));
      /* Kacheln mit Sekunden: Minuten exakt (teile() rundet für Texte ohne Sekunden auf 1 Min. auf) */
      text(el, '[data-flex-einf-m]', zwei(Math.floor((rest % 3600) / 60)));
      text(el, '[data-flex-einf-s]', zwei(Math.floor(rest % 60)));
    }
    var balken = el.querySelector('[data-flex-einf-balken]');
    if (balken) balken.style.width = Math.max(0, Math.min(100, (rest / SIEBEN_TAGE) * 100)).toFixed(1) + '%';

    var kurz = el.querySelectorAll('[data-flex-einf-kurz]');
    for (var i = 0; i < kurz.length; i++) {
      var box = kurz[i];
      var neu = kurzTeile(rest);
      var alt = box.getAttribute('data-flex-einf-kurz-wert');
      if (alt === neu.join('|')) continue;
      box.setAttribute('data-flex-einf-kurz-wert', neu.join('|'));
      while (box.firstChild) box.removeChild(box.firstChild);
      for (var j = 0; j < neu.length; j++) {
        var s = document.createElement('span');
        s.className = 'flex-kachel__cd-k';
        s.textContent = neu[j];
        box.appendChild(s);
      }
    }
  }

  function tick() {
    var jetzt = Date.now() / 1000;
    var els = document.querySelectorAll('[data-flex-einf-ende]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ende = parseInt(el.getAttribute('data-flex-einf-ende'), 10);
      if (!ende || ende <= jetzt) {
        el.classList.add('is-abgelaufen');
        continue;
      }
      aktualisiere(el, ende - jetzt);
    }
  }

  function setze(box, key, wert) {
    var el = box.querySelector('[data-flex-einf-' + key + ']');
    /* Werte stammen aus dem eigenen Liquid-money-Output (ggf. mit Entities wie &euro;) */
    if (el && typeof wert === 'string') el.innerHTML = wert;
  }

  function variante(id) {
    if (!id) return;
    var boxen = document.querySelectorAll('[data-flex-einf-pdp]');
    for (var i = 0; i < boxen.length; i++) {
      var box = boxen[i];
      var json = box.querySelector('[data-flex-einf-varianten]');
      if (!json) continue;
      var map;
      try { map = JSON.parse(json.textContent); } catch (e) { continue; }
      var v = map[String(id)];
      if (!v) continue; /* Variante gehört zu einem anderen Produkt */
      setze(box, 'r', v.r);
      setze(box, 'rn', v.rn);
    }
  }

  /* „i“ hinter 7-Tage-Deal: Antippen öffnet/schließt die Erklärung */
  function infoZu(ausser) {
    var offen = document.querySelectorAll('.flex-einf__text.is-info-offen');
    for (var i = 0; i < offen.length; i++) {
      if (offen[i] === ausser) continue;
      offen[i].classList.remove('is-info-offen');
      var b = offen[i].querySelector('.flex-einf__info');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.flex-einf__info') : null;
    if (!btn) { infoZu(null); return; }
    e.preventDefault();
    var p = btn.closest('.flex-einf__text');
    if (!p) return;
    infoZu(p);
    var auf = !p.classList.contains('is-info-offen');
    p.classList.toggle('is-info-offen', auf);
    btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') infoZu(null); });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && (t.tagName === 'INPUT' || t.tagName === 'SELECT')) variante(t.value);
  });

  /* Neu eingefügte Elemente (Filter/Sortierung/Paginierung, Varianten-Preisblock) gleich prüfen */
  var geplant = null;
  function bald() {
    if (geplant) return;
    geplant = setTimeout(function () { geplant = null; tick(); }, 50);
  }
  function beobachte() {
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var nodes = liste[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-flex-einf-ende') || n.querySelector('[data-flex-einf-ende]')) { bald(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    tick();
    setInterval(tick, 1000);
    beobachte();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          if (ev && ev.data && ev.data.variant) variante(ev.data.variant.id);
        });
      }
    } catch (e) { /* ohne pubsub reicht das change-Event */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
